export enum SystemNoticeType {
  account = "account",
  cardExpired = "cardExpired",
  interpreter = "interpreter"
}
